export default [
	{
		modulo: 15,
		privilegio: 109,
		routerName: 'despacho',
		routerPath: '/despacho',
		componentName: 'Despacho',
		componentPath: 'modules/layout/despacho/mg-siga/main',
		clientsComponentPath: [
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/despacho/pm-es/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/despacho/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/despacho/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/despacho/cm-bahia/main'
			},
			// id da henrimar
			{
				clientId: [25, 37],
				componentPath: 'modules/layout/despacho/vale/main'
			}
		]
	}
]
